import React, { createContext, useContext, useState } from 'react';

export interface CaseIdContextProps {
  activeCaseId: string;
  setActiveCaseId: React.Dispatch<React.SetStateAction<string>>;
}

export const CaseIdContext = createContext<CaseIdContextProps | null>(null);

// use for storing current/active case id
export const CaseIdProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeCaseId, setActiveCaseId] = useState<string>('');

  return (
    <CaseIdContext.Provider
      value={{
        setActiveCaseId,
        activeCaseId,
      }}
    >
      {children}
    </CaseIdContext.Provider>
  );
};

export function useCaseId(): CaseIdContextProps {
  const context = useContext(CaseIdContext);
  return context || assertNever();
}

function assertNever(): never {
  throw Error('Cannot use useCaseId outside of CaseIdProvider');
}
